<template>
  <div class="document-container">
    <div class="columns is-desktop">
      <div class="column">
        <shared-id-search
          @loading="storeLoading"
          @loadingError="storeLoadingError"
          @sharedIdResults="storeResults"
        />
      </div>
      <div class="column is-3">
        <quick-tips-shared-ids/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <shared-id-results
          :loading="loading"
          :loadingError="loadingError"
          :personType="personType"
          :sharedIdResults="sharedIdResults"
          :totalCount="totalCount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SharedIdSearch from '@/components/ID Manager Components/SharedIdSearch.vue';
import QuickTipsSharedIds from '@/components/ID Manager Components/QuickTipsSharedIds.vue';
import SharedIdResults from '@/components/ID Manager Components/SharedIdResults.vue';

export default {
  components: {
    SharedIdSearch,
    QuickTipsSharedIds,
    SharedIdResults,
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      personType: null,
      sharedIdResults: null,
      totalCount: null,
    };
  },
  methods: {
    storeLoading(data) {
      this.loading = data;
    },
    storeLoadingError(data) {
      this.loadingError = data;
    },
    storeResults(data) {
      this.personType = data.selectedPersonType;
      this.sharedIdResults = data.searchResults;
      this.totalCount = data.totalCount;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
